export const apiListNetwork = "/1.0/wsm/package/net/list"
export const apiExportExcelTemplate = "/1.0/wsm/package/net/export"
export const apiImportExcelTemplate = "/1.0/wsm/package/net/import "
export const apiPackageDetail = (id) => `/1.0/wsm/package/net/${id}/detail`
export const apiPackageRequestDetail = (id) => `/1.0/wsm/package/new/${id}/detail`
export const apiPackageUpdate = id => `/1.0/wsm/package/net/${id}/update`;
export const apiPackageDelete = `/1.0/wsm/package/net/delete`;

export const apiListNetworkRequest = "/1.0/wsm/package/new/list"
export const apiPackageRequestUpdate = id => `/1.0/wsm/package/new/${id}/update`;
export const apiApprovePackageRequest = id => `/1.0/wsm/package/new/${id}/approve`;
export const apiRejectPackageRequest = id => `/1.0/wsm/package/new/${id}/reject`;
export const apiImportExcelTemplateNetwork = "/1.0/wsm/package/net/import-price"
export const apiImportExcelPackagePrice = "/1.0/wsm/package/net/import/price/sell"
export const apiExportExcelTemplatePackagePrice = "/1.0/wsm/package/net/export-price"

export const apiExportExcelTemplateUpdatePrice = "/1.0/wsm/package/net/exportPriceBuy"
export const apiImportExcelUpdatePrice = "/1.0/wsm/package/net/importPriceBuy"
